import { createEntityAdapter } from '@reduxjs/toolkit'
import { IOption } from '../../types/option'

export const optionsAdapter = createEntityAdapter<IOption>()